import { useLocation } from "react-router-dom";
import { VacationsHeader, SearchPill, VacationsFooter } from "../VacationsChrome";

export const WebLayout = (props) => {
  const { pathname } = useLocation();
  // The Search page has its own filter bar, so the global search is hidden there.
  const showSearch = !pathname.startsWith('/search');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <VacationsHeader />
      {showSearch && <SearchPill />}
      <div className="container-fluid" style={{ flex: '1 0 auto' }}>
        <div className={`webLayout`}>{props.children}</div>
      </div>
      <VacationsFooter />
    </div>
  );
};
